import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a6738dc2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("新增公告")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 编辑 ")
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "dialog-footer" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("确 定")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_page_content = _resolveComponent("page-content")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_editor = _resolveComponent("editor")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, {
        type: "primary",
        icon: "el-icon-plus",
        onClick: _ctx.addNotice
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_page_content, {
      contentTableConfig: _ctx.contentTableConfig,
      pageName: "notice",
      ref: "pageContentRef",
      pageUrl: "/pc/publish/getNoticeList"
    }, {
      update: _withCtx((scope) => [
        _createVNode(_component_el_button, {
          size: "small",
          type: "primary",
          onClick: ($event: any) => (_ctx.getNoticeContent(scope.row.noticeId))
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]),
      noticeContent: _withCtx(({ row }) => [
        _createElementVNode("div", {
          innerHTML: row.noticeContent,
          class: "notice-content-preview"
        }, null, 8, _hoisted_5)
      ]),
      _: 1
    }, 8, ["contentTableConfig"])), [
      [_directive_loading, _ctx.loading]
    ]),
    (_ctx.dialogVisible)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 0,
          modelValue: _ctx.dialogVisible,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dialogVisible) = $event)),
          title: "公告信息",
          width: "80%",
          "destroy-on-close": ""
        }, {
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_el_button, {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dialogVisible = false))
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                loading: _ctx.submitLoading,
                onClick: _ctx.submitForm
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              }, 8, ["loading", "onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              model: _ctx.form,
              rules: _ctx.rules,
              ref: "formRef",
              "label-width": "100px",
              "label-position": "right"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "公告标题",
                  prop: "noticeTitle"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.noticeTitle,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.noticeTitle) = $event)),
                      placeholder: "请输入公告标题",
                      maxlength: "100",
                      "show-word-limit": ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "公告内容",
                  prop: "noticeContent"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_editor, {
                      class: "editor-container",
                      modelValue: _ctx.form.noticeContent,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.noticeContent) = $event)),
                      text: _ctx.form.noticeContent,
                      onChange: _ctx.changeEditor
                    }, null, 8, ["modelValue", "text", "onChange"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ]))
}